export const categories = [
  {
    slug: 'app-building',
    name: '应用搭建',
    description: '无需代码，通过拖拽组件和可视化配置，快速构建企业级应用系统',
    icon: 'ri-apps-2-line',
    articleCount: 12,
  },
  {
    slug: 'automation',
    name: '自动化流程',
    description: '智能连接业务环节，自动执行重复任务，释放团队创造力',
    icon: 'ri-flow-chart',
    articleCount: 8,
  },
  {
    slug: 'website',
    name: '网站建设',
    description: '从企业官网到电商平台，可视化搭建高性能响应式网站',
    icon: 'ri-window-line',
    articleCount: 10,
  },
  {
    slug: 'digital-transformation',
    name: '数字化转型',
    description: '助力传统企业拥抱数字化浪潮，实现业务流程全面升级',
    icon: 'ri-rocket-line',
    articleCount: 6,
  },
];